export function NotFoundPage() {
  return (
    <section className="hw-page">
      <h1 className="hw-page__title">Страница не найдена</h1>
      <p className="hw-page__body">
        Этот адрес не существует. Используйте навигацию Каталог или Коллекция.
      </p>
    </section>
  );
}
